module.exports = __webpack_public_path__ + "static/img/12.7fc4c80.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue12/01/12.jpeg
// module id = /XQv
// module chunks = 7